module.exports = __webpack_public_path__ + "static/media/neutral.8e6fc9b4.svg";